/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type UserEventExpirationResponse,
    UserEventExpirationResponseFromJSON,
    UserEventExpirationResponseToJSON,
} from '../models/UserEventExpirationResponse';
import {
    type UserEventExpirationUpdateRequest,
    UserEventExpirationUpdateRequestFromJSON,
    UserEventExpirationUpdateRequestToJSON,
} from '../models/UserEventExpirationUpdateRequest';

export interface ApiUserEventExpiryEditPutRequest {
    userEventExpirationUpdateRequest: UserEventExpirationUpdateRequest;
}

/**
 * 
 */
export class UserEventExpiryApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiUserEventExpiryEditPut without sending the request
     */
    async apiUserEventExpiryEditPutRequestOpts(requestParameters: ApiUserEventExpiryEditPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userEventExpirationUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'userEventExpirationUpdateRequest',
                'Required parameter "userEventExpirationUpdateRequest" was null or undefined when calling apiUserEventExpiryEditPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/user-event-expiry/edit`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserEventExpirationUpdateRequestToJSON(requestParameters['userEventExpirationUpdateRequest']),
        };
    }

    /**
     */
    async apiUserEventExpiryEditPutRaw(requestParameters: ApiUserEventExpiryEditPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiUserEventExpiryEditPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUserEventExpiryEditPut(requestParameters: ApiUserEventExpiryEditPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserEventExpiryEditPutRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiUserEventExpirySearchPost without sending the request
     */
    async apiUserEventExpirySearchPostRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/user-event-expiry/search`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUserEventExpirySearchPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserEventExpirationResponse>>> {
        const requestOptions = await this.apiUserEventExpirySearchPostRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserEventExpirationResponseFromJSON));
    }

    /**
     */
    async apiUserEventExpirySearchPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserEventExpirationResponse>> {
        const response = await this.apiUserEventExpirySearchPostRaw(initOverrides);
        return await response.value();
    }

}
